// sdk登录
import { Txh5UniSDK, UnisdkLoginType } from 'txh5-lib/H5SDK/auth';
import { onMounted } from 'vue';
import loadScriptPromise from '../utils/loadScriptPromise';
export default function useLogin() {
  // tx3:端游
  // txm:手游
  // tx2:天下贰
  const sdk = ref(null);
  async function unisdk_init() {
    sdk.value = new Txh5UniSDK(import.meta.env.VITE_TEAM, 'official', () => { });
    sdk.value.loginType = UnisdkLoginType.PHONE_AND_EMAIL;
    await sdk.value.init();
  }

  async function login(callback) {
    sdk.value.unisdkSauthApi = async (res) => {
      return await fetch(
        `${import.meta.env.VITE_BASEAPI}/user/h5_unisdk_sauth`,
        {
          method: 'POST',
          body: JSON.stringify({
            sauth_json: res,
            gameId: 'g20',
            loginChannel: 'netease',
            project: import.meta.env.VITE_TEAM,
            activity: import.meta.env.VITE_NAME,
          }),
        }
      ).then((res) => {
        return res.json();
      });
    };
    // sdk.value.setCustomUnisdkExtProp('NETEASE_CHANNEL_MPAY_CSS_DOMAIN', 'https://g20.gsf.netease.com')
    // sdk.value.setCustomUnisdkExtProp('NETEASE_CHANNEL_URS_CSS_FILES', '/2025082501/2025082501/login_email.css')
    await sdk.value.login(
      (data) => {
        console.log('unisdk login success', data);
        callback(true);
        sdk.value.logout();
      },
      (error) => {
        callback(false);
        console.log('unisdk login fail', error);
        sdk.value.logout();
      }
    );
  }

  async function txmLogin(loginSuccess) {
    await login(loginSuccess);
  }

  async function tx3Login(loginSuccess) {
    await login(loginSuccess);
  }

  function logout() {
    sdk.value.logout();
  }
  onMounted(async () => {
    await loadScriptPromise(
      'https://mpay-web.g.mkey.163.com/h5/p4.2.4/static/js/netease-h5-mpay-sdk.umd.js'
    );

    await unisdk_init();
  });

  return {
    txmLogin,
    tx3Login,
    logout,
  };
}
